import { render } from "./Appointments.vue?vue&type=template&id=e87c516c"
import script from "./Appointments.vue?vue&type=script&lang=js"
export * from "./Appointments.vue?vue&type=script&lang=js"

import "./Appointments.vue?vue&type=style&index=0&id=e87c516c&lang=scss"
script.render = render

export default script